import api from "@/api/comptabilite/_rapport_caisse";
import DateFilter from '@/components/date-filter';
import RapportRecette from '@/components/comptable/dashboard/rapport-recette'
import RapportVente from '@/components/comptable/dashboard/rapport-vente'
// import RapportTouteDepenseCaisse from '@/components/comptable/dashboard/rapport-toutes-depenses'
// import RapportDepenseCaisse from '@/components/comptable/dashboard/rapport-depense-caisse'
// import RapportDepenseCaisseAnnulee from '@/components/comptable/dashboard/rapport-depense-caisse-annulee'
import RapportVersement from '@/components/comptable/dashboard/rapport-versement'
import RapportReportReliquat from '@/components/comptable/dashboard/rapport-report-reliquat'
import RapportReglementReliquat from '@/components/comptable/dashboard/rapport-reglement-reliquat'
import RapportAnnulation from '@/components/comptable/dashboard/rapport-annulation'
// import RapportApportSocial from '@/components/comptable/dashboard/rapport-apport-social'
import RapportCoupon from '@/components/comptable/dashboard/rapport-coupon'
import RapportCreance from '@/components/comptable/dashboard/rapport-creance'
import RapportEcartCaisse from '@/components/comptable/dashboard/rapport-ecart-caisse'

import $ from 'jquery'

// RapportDepenseCaisse, RapportDepenseCaisseAnnulee, RapportApportSocial, RapportTouteDepenseCaisse

export default {
    name: 'tab-finance',
    components: {
        DateFilter, RapportRecette, 
        RapportVersement, RapportReportReliquat, RapportReglementReliquat, 
        RapportAnnulation,  RapportCoupon, RapportCreance,
        RapportEcartCaisse, RapportVente
    },
    props: {
        liste_personnel_roles: Array
    },

    data() {
        return {
            rapport_caisse: {},
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            personnel_id: "",
            personnel: '',

            type_produits: [
                { 'data_type': 'tous', 'libelle': 'Tous les produits' },
                { 'data_type': 'bon_consultation', 'libelle': 'Consultations' },
                { 'data_type': 'analyse', 'libelle': 'Analyses' },
                { 'data_type': 'examen', 'libelle': 'Examens' },
                { 'data_type': 'medicament', 'libelle': 'Médicaments' },
                { 'data_type': 'consommable', 'libelle': 'Consommables' },
                { 'data_type': 'chirurgie', 'libelle': 'Chirurgies' },
                { 'data_type': 'bilan_sante', 'libelle': 'Bilan de santé' },
                { 'data_type': 'admission', 'libelle': 'Admissions' },
                { 'data_type': 'acte', 'libelle': 'Actes' },
                { 'data_type': 'observation', 'libelle': 'Observations' },
                { 'data_type': 'chambre', 'libelle': 'Chambres' },
                { 'data_type': 'consommable_bon', 'libelle': 'Consommables de bon de consultation' },
            ],
            filter_type_produit: { 'data_type': 'tous', 'libelle': 'Tous les produits' },
            operation_loading: true,
            compte_id: 1,
            solde_av_versement: 0,
            solde_ap_versement: 0,
            recette: 0,
            total_vente: 0,
            total_annulation: 0,
            total_coupon: 0,
            total_creance: 0,
            total_ecart_caisse: 0,

            filter_creances: [
                { etat_paiement: 'tout', libelle: 'Créances' },
                { etat_paiement: 'diferee', libelle: 'Différées' },
                { etat_paiement: 'restant', libelle: 'Reste à payer' }
            ],
            selected_creance: 'Créances',

            filter_ecarts_caisse: [
                { libelle: 'Écarts caisse' },
                { libelle: 'Écarts positifs' },
                { libelle: 'Écarts négatifs' }
            ],
            selected_ecart: 'Écarts caisse',
            by_type_ecart: '',

            liste_prestations: [
                { 'libelle': 'Tout' }
            ],
            filter_prestation: { 'libelle': 'Tout' },
            can_filter_by_prestation: false,
            is_na: false,
            tmp_grouped_prestations: [],
            tmp_grouped_annulations: [],
            tmp_grouped_coupons: [],
            tmp_grouped_creances: [],
            tmp_grouped_ventes: [],
            modal_toggler: 0,
            by_prestation: '',
            by_type_creance: ''
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                compte_id: this.compte_id,
                user_id: this.personnel_id,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                filter_option: this.filter_type_produit,
                libelle: this.filter_prestation.libelle
            }
            this.current_date_filter = data
            this.is_month = true
            this.getRapportCaisses()
        },

        personnel() {
            this.personnel_id = this.personnel.id

            this.current_date_filter.user_id = this.personnel_id
            this.current_date_filter.filter_option = this.filter_type_produit
            this.getRapportCaisses()
        },

        filter_type_produit() {
            this.liste_prestations = [{ 'libelle': 'Tout' }]
            this.filter_prestation = { 'libelle': 'Tout' }
            this.current_date_filter.filter_option = this.filter_type_produit
            this.current_date_filter.libelle = this.filter_prestation.libelle
            if (this.filter_type_produit.data_type == 'tous') {
                this.can_filter_by_prestation = false
                this.is_na = false
            } else {
                this.can_filter_by_prestation = true
                this.is_na = true
            }

            this.getRapportCaisses()
        },

        filter_prestation() {
            this.selected_creance = 'Créances'
            this.current_date_filter.libelle = this.filter_prestation.libelle
            // this.calcRapportPrestation()

            if (this.filter_prestation.libelle == 'Tout') {
                this.by_prestation = ''
            } else {
                this.by_prestation = this.filter_prestation.libelle
            }
        },

        selected_creance() {
            this.handleCreance()
        },

        selected_ecart() {
            this.handleEcartCaisse()
        }
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        solde_du_jour() {
            return this.$store.getters["solde_du_jour"];
        },
    },

    mounted () {
        const data = {
            compte_id: this.compte_id,
            user_id: this.personnel_id,
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.getRapportCaisses()

        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },

    methods: {
        selectRapportCaisse(data) {
            return new Promise((resolve, reject) => {
                api.getRapportCaisse(data).then(
                    (response) => {
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },

        getRapportCaisses() {
            this.selected_creance = 'Créances'
            this.selected_ecart = 'Écarts caisse'
            this.by_type_ecart = ''
            this.recette = 0
            this.total_vente = 0
            this.solde_av_versement = 0
            this.solde_ap_versement = 0
            this.operation_loading = true
            this.rapport_caisse = {}
            this.selectRapportCaisse(this.current_date_filter).then((rapport) => {
                this.rapport_caisse = rapport
                this.total_annulation = rapport.total_annulation
                this.total_coupon = rapport.total_coupon
                this.total_creance = rapport.total_creance
                this.total_ecart_caisse = rapport.total_ecart_caisse


                // Recette
                this.recette = rapport.total_recette
                this.total_vente = rapport.total_vente

                // Solde avant versement
                this.solde_av_versement = rapport.total_recette - rapport.total_depense_caisse

                // Solde apres versement
                this.solde_ap_versement = this.solde_av_versement - rapport.total_versement

                if (this.filter_type_produit.data_type != 'tous') {
                    
                    this.tmp_grouped_prestations = rapport.recettes.groupBy('data_type')
                    this.tmp_grouped_ventes = rapport.ventes.groupBy('data_type')

                    // Annulation
                    this.tmp_grouped_annulations = rapport.annulations.groupBy('data_type')

                    // Coupons
                    this.tmp_grouped_coupons = rapport.coupons.groupBy('data_type')

                    // Creances
                    this.tmp_grouped_creances = rapport.creances.groupBy('data_type')


                    this.liste_prestations = [{ 'libelle': 'Tout' }]
                    for (const key in this.tmp_grouped_prestations) {
                        if (key == this.filter_type_produit.data_type) {
                            const tmp_grouped_selected_prestations = this.tmp_grouped_prestations[key].groupBy('libelle')

                            for (const libelle in tmp_grouped_selected_prestations) {
                                let tmp_lib = {
                                    libelle: libelle
                                }
                                this.liste_prestations.push(tmp_lib)
                            }
                        }
                    }
                }

                this.operation_loading = false
            })
        },

        filterByDate(date) {
            this.operations_tobe_canceled = []
            const data = {
                compte_id: this.compte_id,
                user_id: this.personnel_id,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                filter_option: this.filter_type_produit,
                libelle: this.filter_prestation.libelle
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getRapportCaisses()
        },

        calcRapportPrestation() {
            this.recette = 0
            
            const l_prestations = this.tmp_grouped_prestations[this.filter_type_produit.data_type]
            if (l_prestations) {
                l_prestations.forEach(prestation => {
                    if (this.filter_prestation.libelle == prestation.libelle) {
                        this.recette += prestation.recette
                    } else if (this.filter_prestation.libelle == 'Tout') {
                        this.recette += prestation.recette
                    }
                });
            }

            this.calcGroupedCoupons()

            this.calcGroupedCreances()

            this.calcGroupedAnnulations()

            this.calcGroupedVentes()
        },

        calcGroupedVentes() {
            this.total_vente = 0
            const vente_prestations = this.tmp_grouped_ventes[this.filter_type_produit.data_type]
            if (vente_prestations) {
                vente_prestations.forEach(prestation => {
                    if (this.filter_prestation.libelle == prestation.libelle) {
                        this.total_vente += prestation.montant
                    } else if (this.filter_prestation.libelle == 'Tout') {
                        this.total_vente += prestation.montant
                    }
                });
            }
        },

        calcGroupedCoupons() {
            this.total_coupon = 0
            const coupon_prestations = this.tmp_grouped_coupons[this.filter_type_produit.data_type]
            if (coupon_prestations) {
                coupon_prestations.forEach(prestation => {
                    if (this.filter_prestation.libelle == prestation.libelle) {
                        this.total_coupon += prestation.montant
                    } else if (this.filter_prestation.libelle == 'Tout') {
                        this.total_coupon += prestation.montant
                    }
                });
            }
        }, 

        calcGroupedCreances() {
            this.total_creance = 0
            const creance_prestations = this.tmp_grouped_creances[this.filter_type_produit.data_type]
            if (creance_prestations) {
                creance_prestations.forEach(prestation => {
                    if (this.filter_prestation.libelle == prestation.libelle) {
                        this.total_creance += prestation.montant_a_payer
                    } else if (this.filter_prestation.libelle == 'Tout') {
                        this.total_creance += prestation.montant_a_payer
                    }
                });
            }
        }, 

        calcGroupedAnnulations() {
            this.total_annulation = 0
            const annulation_prestations = this.tmp_grouped_annulations[this.filter_type_produit.data_type]
            if (annulation_prestations) {
                annulation_prestations.forEach(prestation => {
                    if (this.filter_prestation.libelle == prestation.libelle) {
                        this.total_annulation += prestation.montant
                    } else if (this.filter_prestation.libelle == 'Tout') {
                        this.total_annulation += prestation.montant
                    }
                });
            }
        },

        viewRecette() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-recette').modal('show')  
        },
         
        viewDepenseCaisse() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-depense-caisse').modal('show')  
        },

        viewVersement() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-versement').modal('show') 
        },

        viewReportReliquat() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-report-reliquat').modal('show') 
        },

        viewReglementReliquat() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-reglement-reliquat').modal('show') 
        },

        viewAnnulation() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-annulation').modal('show') 
        },

        viewApportSociaux() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-apport-social').modal('show') 
        },

        viewCoupon() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-coupon').modal('show') 
        },
        
        viewCreance() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-creance').modal('show') 
        }, 

        viewEcartCaisse() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-ecart-caisse').modal('show') 
        },

        viewVente() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-vente').modal('show') 
        },

        viewDepenseCaisseAnnulee() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-depense-caisse-annulee').modal('show') 
        },

        viewAllDepenseCaisse() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-toutes-depenses').modal('show')
        },

        handleCreance() {
            let etat_paiement = ''
            if (this.selected_creance == 'Créances') {
                etat_paiement = 'tout'
            } else if (this.selected_creance == 'Différées') {
                etat_paiement = 'diferee'
            } else if (this.selected_creance == 'Reste à payer') {
                etat_paiement = 'restant'
            }   
            this.by_type_creance = etat_paiement

            Array.prototype.groupBy = function (key) {
                return this
                    .reduce((hash, obj) => {
                        if (obj[key] === undefined) return hash;
                        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                    }, {})
            };

            this.total_creance = 0
            const creance_prestations = this.rapport_caisse.creances
            const tmp_grouped_creances = creance_prestations.groupBy('etat_paiement')

            if (etat_paiement == 'tout') {
                creance_prestations.forEach(prestation => {
                    if (this.filter_prestation.libelle == prestation.libelle) {
                        this.total_creance += prestation.montant_a_payer
                    } else if (this.filter_prestation.libelle == 'Tout') {
                        this.total_creance += prestation.montant_a_payer
                    }
                });
            } else {
                const selected_type_creance = tmp_grouped_creances[etat_paiement]

                selected_type_creance.forEach(prestation => {
                    if (this.filter_prestation.libelle == prestation.libelle) {
                        this.total_creance += prestation.montant_a_payer
                    } else if (this.filter_prestation.libelle == 'Tout') {
                        this.total_creance += prestation.montant_a_payer
                    }
                });
            }
        },

        handleEcartCaisse() {
            this.total_ecart_caisse = 0
            const ecarts_prestations = this.rapport_caisse.ecarts_caisse
            ecarts_prestations.forEach(prestation => {
                if (this.selected_ecart == 'Écarts caisse') {
                    this.by_type_ecart = ''
                    this.total_ecart_caisse += prestation.ecart_caisse
                } else if (this.selected_ecart == 'Écarts positifs') {
                    this.by_type_ecart = 'ecart_positif'
                    if (prestation.ecart_caisse > 0) {
                        this.total_ecart_caisse += prestation.ecart_caisse
                    }
                } else if (this.selected_ecart == 'Écarts négatifs') {
                    this.by_type_ecart = 'ecart_negatif'
                    if (prestation.ecart_caisse < 0) {
                        this.total_ecart_caisse += prestation.ecart_caisse
                    }
                }
            });
            console.log(this.selected_ecart);
        }
    }
}